interface ErrorStateProps {
    title?: string;
    message?: string;
    buttonText?: string;
    onButtonClick?: () => void;
    icon?: string;
    showButton?: boolean;
}

export default function ErrorState({
                                       title = "Kurs nicht gefunden",
                                       message = "Der angeforderte Kurs existiert nicht oder du hast keine Berechtigung.",
                                       buttonText = "← Zurück zu den Kursen",
                                       onButtonClick,
                                       icon = "❌",
                                       showButton = true
                                   }: ErrorStateProps) {
    return (
        <div className="flex items-center justify-center min-h-screen">
            <div className="text-center animate-fadeIn">
                <div className="text-6xl mb-6 text-red-500">{icon}</div>
                <h2 className="text-2xl font-bold mb-3 text-gray-800">
                    {title}
                </h2>
                <p className="text-gray-600 mb-8 max-w-md">
                    {message}
                </p>
                {showButton && onButtonClick && (
                    <button
                        onClick={onButtonClick}
                        className="px-6 py-3 rounded-lg bg-gradient-to-r from-green-500 to-green-600 text-white font-semibold cursor-pointer transition-all hover:shadow-lg hover:shadow-green-500/20 hover:-translate-y-0.5"
                    >
                        {buttonText}
                    </button>
                )}
            </div>
        </div>
    );
}